import apiService from './apiService';
import preparatoryApiService from './preparatoryApiService';
import middleApiService from './middleApiService';

/**
 * Determines if a grade level belongs to the preparatory stage
 *
 * @param {number|string} grade - The grade level
 * @returns {boolean} - True if preparatory stage (grades 3-5), false otherwise
 */
export const isPreparatoryGrade = (grade) => {
    // Convert grade to a number if it's a string
    const gradeNum = typeof grade === 'string' ? parseInt(grade, 10) : grade;

    // Grades 3-5 are preparatory stage
    return gradeNum >= 3 && gradeNum <= 5;
};

/**
 * Determines if a grade level belongs to the middle stage
 *
 * @param {number|string} grade - The grade level
 * @returns {boolean} - True if middle stage (grades 6-8), false otherwise
 */
export const isMiddleGrade = (grade) => {
    // Convert grade to a number if it's a string
    const gradeNum = typeof grade === 'string' ? parseInt(grade, 10) : grade;

    // Grades 6-8 are middle stage
    return gradeNum >= 6 && gradeNum <= 8;
};

/**
 * Returns the appropriate API service based on grade level
 *
 * @param {number|string} grade - The grade level
 * @returns {object} - The appropriate API service
 */
export const getApiServiceForGrade = (grade) => {
    if (isMiddleGrade(grade)) {
        return middleApiService;
    } else if (isPreparatoryGrade(grade)) {
        return preparatoryApiService;
    } else {
        return apiService;
    }
};

/**
 * Helper function to transform assessment data between API formats if needed
 *
 * @param {object} data - The assessment data
 * @param {boolean} isPreparatory - Whether this is for preparatory stage
 * @param {boolean} isMiddle - Whether this is for middle stage
 * @returns {object} - Transformed data suitable for the API
 */
export const transformAssessmentData = (data, isPreparatory, isMiddle = false) => {
    // This function can be used to transform data between different API formats if needed
    // For now, it just returns the original data
    return data;
};